import {
    BooleanInput,
    Create,
    NumberInput,
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Calculator } from 'lucide-react';
import { required } from 'ra-core';

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const TaxSlabCreate = () => (
    <Create>
        <SimpleForm className="max-w-4xl mx-auto space-y-6">
            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-muted/50">
                    <div className="flex items-center gap-2">
                        <Calculator className="w-5 h-5 text-indigo-500" />
                        <CardTitle className="text-lg font-semibold tracking-tight">New Tax Slab</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <p className="text-xs text-muted-foreground mb-6">Define localized GST rates like CGST, SGST, IGST</p>


            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-2xl mb-4">
                <TextInput source="name" label="Slab Name (e.g. GST 18%)" validate={required()} className="w-full" />
                <BooleanInput source="is_active" label="Active" defaultValue={true} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full max-w-2xl mb-4">
                <NumberInput source="cgst_rate" label="CGST %" defaultValue={9} validate={required()} className="w-full" />
                <NumberInput source="sgst_rate" label="SGST %" defaultValue={9} validate={required()} className="w-full" />
                <NumberInput source="igst_rate" label="IGST %" defaultValue={18} validate={required()} className="w-full" />
            </div>
                </CardContent>
            </Card>
        </SimpleForm>
    </Create>
);
